export default __webpack_public_path__ + "static/media/logo.86e394f5.png";